import throttle from 'lodash-es/throttle';

interface ScrollWindowOpts {
  alwaysStartCenter: boolean;
}

export function ScrollWindow(opts?: ScrollWindowOpts) {
  const left = document.querySelector<HTMLElement>('.ScrollWindow-left');
  const right = document.querySelector<HTMLElement>('.ScrollWindow-right');
  const content = document.querySelector<HTMLElement>('.ScrollWindow-content');
  const item = document.querySelector<HTMLElement>(
    '.ScrollWindow-content > div'
  );

  if (!content || !left || !right) {
    return null;
  }

  function scroll(direction: 'left' | 'right') {
    const delta = direction === 'left' ? -200 : 200;
    if (content) {
      content.scrollTo({
        left: content.scrollLeft + delta,
        behavior: 'smooth',
      });
    }
  }

  if (left) {
    left.addEventListener('click', () => scroll('left'));
  }

  if (right) {
    right.addEventListener('click', () => scroll('right'));
  }

  /**
   *
   *
   * We split the scrollable area into five alternatives:
   *
   */

  let initialLeftPosition: number = 0;

  if (!item) {
    return null;
  }

  if (opts?.alwaysStartCenter) {
    initialLeftPosition = (item.clientWidth - content.clientWidth) / 2;
  } else {
    const leftBoundary = 80;
    const rightBoundary = item.clientWidth - content.clientWidth - 80;

    const scrollPositions = [
      // Left boundary
      leftBoundary,

      // Left/middle boundary
      ((rightBoundary - leftBoundary) / 2 - leftBoundary) / 2,

      // Middle
      (rightBoundary - leftBoundary) / 2,

      // Middle/right
      (rightBoundary - (rightBoundary - leftBoundary) / 2) / 2,

      // Right boundary
      rightBoundary,
    ];

    const initialScrollPos = Math.floor(Math.random() * Math.floor(5));

    initialLeftPosition = scrollPositions[initialScrollPos];
  }

  content.scrollTo({
    left: initialLeftPosition,
  });

  function resize() {
    if (!item || !left || !right || !content) {
      return null;
    }
    const hideScrollArrows = item.clientWidth > content.clientWidth + 2;
    left.style.display = hideScrollArrows ? 'block' : 'none';
    right.style.display = hideScrollArrows ? 'block' : 'none';
  }

  window.addEventListener('resize', throttle(resize, 5, { trailing: true }));

  resize();
}
